<template>
  <div id="app" :style="{ height: screeHeight + 'px', overflow: 'hidden' }">
    <!-- {{screeHeight}} -->
    <!-- <img src="./assets/logo.png"> :key="$route.path" -->

    <router-view />
  </div>
</template>

<script>

import api from "@/api";
export default {
  name: "App",
  data() {
    return {
      screeHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      requestid: '',
      code: '',
      ticket: ''
    };
  },
  mounted() {
    if (this.$route.query.token) {
      localStorage.setItem("token", this.$route.query.token);
    }
    let list = this.getUrlCode()
    this.requestid = list.requestid
    this.ticket = list.ticket
    this.code = list.code
    this.menhu = list.menhu
    if (this.requestid) {
      this.user_login_third()
    }
    if (this.ticket) {
      this.user_login_third1()
    }
    if (list.code) {
      this.user_login_thirds()
    }
    window.addEventListener('unload', this.saveState)
  },
  methods: {
    // 获取二维码参数
    getUrlCode() {
      // 截取url中的code方法
      let url = window.location.href; //'http://wap.kechengzhijia.com/#/invitalpay?'+encodeURIComponent('com_id=5');
      url = decodeURIComponent(url);
      var theRequest = new Object();
      if (url.indexOf("?") != -1) {
        var str = url.split("?")[1];
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]] = strs[i].split("=")[1];
        }
      }
      return theRequest;
    },
    user_login_third() {
      var data = {
        'third_type': 'xm_kczj',
        'third_code': this.requestid,
        'third_name': 'jingshi',
        'login_type': this.login_type
      };
      api.user_login_third(data).then(res => {
        this.save(res.data.rtdata)
      }).catch(r => {

      });
    },
    user_login_third1() {
      var data = {
        'third_type': 'xm_kczj',
        'third_code': this.ticket,
        'third_name': 'ty_xingyang',
        'login_type': this.login_type
      };
      api.user_login_third(data).then(res => {
        this.save(res.data.rtdata)
      }).catch(r => {

      });
    },
    user_login_thirds() {
      var data = {
        'third_type': 'kczj',
        'third_code': this.code,
        'third_name': 'shuangjian',
        'login_type': this.login_type
      };
      api.user_login_third(data).then(res => {
        console.log(res)
        this.save(res.data.rtdata)
      }).catch(r => {

      });
    },
    save(result) {
      localStorage.setItem("fromqw", result.fromqw);
      //存登陆token
      this.$store.dispatch("loginAfterValue", result.token);
      this.$store.commit("UPDATE_USERINFO", result);
      console.log(result)
      if (
        result.login_role == 102 ||
        result.login_role == 101 ||
        result.login_role == 153 ||
        result.login_role == 103 ||
        result.login_role == 130
      ) {
        this.$store.commit("ROLE", 1); //管理员 教育局
        localStorage.setItem("showFlag", false);
        localStorage.setItem("login_role", result.login_role);
        this.getList();
      } else {
        //教师身份
        if (
          result.login_role == 111 ||
          result.login_role == 110 ||
          result.login_role == 112 ||
          result.login_role == 116 ||
          result.login_role == 119
        ) {
          //课管家
          window.location.href = localStorage.getItem("html");
          return;
        } else {
          this.$store.commit("UPDATE_TOPNAV", "0-0"); //顶部菜单选中
          this.$store.commit("ROLE", 2);
          this.getUlist();
        }
      }
    },
    //获取教师顶部菜单
    getUlist() {
      api
        .getUlist()
        .then((json) => {
          if (
            json.data.code == 200 &&
            json.data.rtdata &&
            json.data.rtdata.length
          ) {
            // this.totals = json.data.rtcount{'com_property':'11','module_url':'/'};
            var res = json.data.rtdata;
            let obj = [];
            let keys = [];
            let arr = res.map((item) => {
              let com = {
                com_property: "",
                child: [],
              };
              if (keys.indexOf(item.com_property) == "-1") {
                keys.push(item.com_property);
                if (item.com_property != 3) {
                  com["com_property"] = item.com_property;
                  item["module_name"] = item.com_name;
                  item["school_name"] = item.school_name;
                  com.child.push(item);
                }
                if (item.com_property == 3) {
                  com["com_property"] = item.com_property;
                  item["module_name"] = item.subject_name;
                  item["school_name"] = item.school_name;
                  com.child.push(item);
                }
                obj.push(com);
              } else {
                let rs = obj.map((its) => {
                  if (its.com_property == item.com_property) {
                    if (item.com_property == 3) {
                      item["module_name"] = item.subject_name;
                      item["school_name"] = item.school_name;
                    } else {
                      item["module_name"] = item.com_name;
                      item["school_name"] = item.school_name;
                    }
                    its.child.push(item);
                  }
                  return its;
                });
              }
            });
            this.$store.commit("UPDATE_TOPMENU", obj); //顶部菜单
            let d = {
              type: res[0].com_property,
              id: res[0].com_id,
            };
            if (res[0].com_property == 3) {
              d["id"] = res[0].user_id;
              (d["grade_id"] = res[0].grade_id),
                (d["subject_id"] = res[0].subject_id);
            }
            let url =
              res[0].com_property == 3
                ? "/class/club-evaluate"
                : "/class/club-info";
            localStorage.setItem("showFlag", false);
            if (res[0].module_property == 2) {
              window.location.href =
                localStorage.getItem("html") +
                that.html[i].module_url +
                "?id=" +
                res[0].module_code;
              return false;
            } else {
              this.$router.push({
                path: url,
                query: {
                  type: JSON.stringify(d),
                },
              });
            }
            return;
          }
          this.$router.push({
                path: '/collaborator/classlist',
              });
          // this.$message.error("请联系管理员开通权限获取课程");
        })
        .catch((r) => {
          let errTips = r.msg;
          this.$message.error(errTips || "出错了");
        });
    },
    //获取用户信息
    getUser() {
      api.getUserInfo().then((json) => {
        let res = json.data;
        if (res.rtdata) {
          this.$store.commit("UPDATE_USERINFO", res.rtdata);
          return;
        }
        this.$message.error(res.msg || "出错了");
      });
    },
    getList(key) {
      let data = {
        system_code: 2,
        module_parentcode: key ? key : 0,
      };
      api
        .getMeunList(data)
        .then((json) => {
          let list = json.data.rtdata;
          this.$store.commit("UPDATE_TOPMENU", list); //顶部菜单
          this.$store.commit("UPDATE_TOPNAV", "0"); //顶部菜单选中
          this.$store.commit("UPDATE_LEFTNAV", "0"); //侧边菜单选中
          let url = "";
          if (
            localStorage.login_role == 130 ||
            localStorage.login_role == 102
          ) {
            //教育局
            url = list[0].module_url;
            this.$router.push(url);
          }
          if (list[0].module_property == "2") {
            window.location.href =
              localStorage.getItem("html") +
              list[0].module_url +
              "?id=" +
              list[0].module_code;
            return false;
          } else {
            window.location.href = "http://" + window.location.hostname + '/#' + url;
            // this.$router.push(url);
          }
        })
        .catch();
    },
    // saveState() {
    //     sessionStorage.setItem('state', JSON.stringify(this.$store.state))
    // }
  },
};
</script>
<style>
.hove:hover {
  cursor: pointer;
}

.hoves:hover {
  cursor: pointer;
}

.hove {
  color: #1d99f8;
  font-size: 12px;
}

.conner {
  text-align: center !important;
  font-weight: 400;
  color: black;
}</style>



// WEBPACK FOOTER //
// src/App.vue